import React, {useState} from 'react'
import {Button, HollowButton} from '../../../components/Button'
import {Container, ColContainer, TPL_50_50, CardContainer} from '../../../components/Container';
import {ValidationErrorMessage} from '../../../components/ErrorMessage';
import {H2} from '../../../components/Typography';
import {useFormState} from 'react-use-form-state'
import {useMutation, useQuery} from "@apollo/client"
import {withInstallation} from '../../../components/InstallationContext';
import {
    getSanctionedTimeById,
    updateSanctionedTimeMutation,
    deleteSanctionedTimeMutation
} from './queries';
import moment from "moment";
import {Loading, LoadingError} from "../../../components/LoadingFork";
import {Alert} from "../../../components/Alert";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {DateTimeInput} from "../../../components/DateTimeInput";


function SanctionedTimeUpdate({ sanctionedTime, id, history, installationId }) {
    const [open, setOpen] = React.useState(false);
    const [updateSanctionedTime] = useMutation(updateSanctionedTimeMutation);

    const [deleteSanctionedTime] = useMutation(deleteSanctionedTimeMutation);

    const [{errors, values, setField}] = useFormState({
        startDate: moment(sanctionedTime.start_date).format('YYYY-MM-DDTHH:mm:ss'),
        endDate: moment(sanctionedTime.end_date).format('YYYY-MM-DDTHH:mm:ss'),
    });

    const [hasErrors, setHasErrors] = useState(!!Object.values(errors)[0]);

    async function onUpdate() {
        const {data} = await updateSanctionedTime({
            variables: {
                input: {
                    id: id,
                    start_date: values.startDate,
                    end_date: values.endDate,
                }
            },
        });

        if (data.updateSanctionedTimeById) history.goBack();
        else setHasErrors(true);
    }

    const deleteSubmit = async () => {
        setOpen(false);

        await deleteSanctionedTime({
            variables: {
                id,
                installationId
            }
        });

        history.goBack();
    };

    return <div>
        <CardContainer>
            <Container spaceAbove="medium" spaceBelow="medium">
                <H2>Sanctioned Time Details</H2>
                {hasErrors && <ValidationErrorMessage spaceBelow="medium" error={'Something went wrong. Please, try again later.'}/>}

                <ColContainer columnTemplate={TPL_50_50} spaceAbove="medium">
                    <DateTimeInput
                      floatPicker
                      value={moment(values.startDate)}
                      name={'startDate'}
                      onChange={(date) => {
                          setField('startDate', date.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                    />

                    <DateTimeInput
                      floatPicker
                      value={moment(values.endDate)}
                      name={'endDate'}
                      onChange={(date) => {
                          setField('endDate', date.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                    />
                </ColContainer>
            </Container>
            <ColContainer spaceBelow='medium'>
                <Button type="submit" style={{'cursor': 'pointer'}} spaceAbove="small"
                        flavour='primary'
                        onClick={(values) => onUpdate(values)}>
                    Update
                </Button>
                <Button style={{'cursor': 'pointer'}} flavour="gray" spaceAbove="small" onClick={() => history.goBack()}>
                    Cancel
                </Button>
            </ColContainer>
            <Button
              block
              flavour='danger'
              onClick={() => setOpen(true)}
            >
                Delete
            </Button>
        </CardContainer>

        <Dialog
            open={open}
            onClose={() => {
                setOpen(false)
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete this record ?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <HollowButton
                    size={"small"}
                    onClick={() => setOpen(false)}
                >
                    Cancel
                </HollowButton>
                <HollowButton
                    size={"small"}
                    flavour='danger'
                    onClick={deleteSubmit} autoFocus>
                    Delete
                </HollowButton>
            </DialogActions>
        </Dialog>

    </div>
}

function SanctionedDetail({match, history, installation}) {

    const {id} = match.params

    const [showSuccessMessage, setSuccessMessage] = useState(false)
    const {data = {}, loading, error} = useQuery(getSanctionedTimeById, {
        fetchPolicy: 'no-cache',
        variables: {
            id: id
        }
    });

    if (loading) return (<CardContainer><Loading/></CardContainer>);
    if (error) return (<CardContainer><LoadingError error={error}/></CardContainer>);
    const sanctionedTime = data.getSanctionedById;

    return (
        <CardContainer>
            <div>
                <Container spaceAbove="small" spaceBelow="small">
                    {showSuccessMessage && <Alert flavour="success">Your changes have been saved.</Alert>}
                    <SanctionedTimeUpdate
                        sanctionedTime={sanctionedTime}
                        id={id}
                        history={history}
                        setSuccessMessage={setSuccessMessage}
                        installationId={installation.id}
                        timezone={installation.timeZoneName}
                    />
                </Container>
            </div>
        </CardContainer>
    )
}

export default withInstallation(SanctionedDetail)
